import React from "react";
import Webcam from "react-webcam";
import RoundButton from "../../../Common/RoundButton";
const WebCam = ({
    capture,
    webcamRef,
}: any) => {
    const videoConstraints = {
        // width: 1280,
        // height: 720,
        facingMode: { exact: "environment" }
        // facingMode: "user"
      };
    return (
        <>
            <div style={{ marginTop: '20px', marginBottom: '10px' }}>
                
                    <Webcam
                        audio={false}
                        ref={webcamRef}
                        screenshotFormat="image/jpeg"
                        width={320}
                        videoConstraints={videoConstraints}
                    />
                   
            </div>
            <div style={{ marginTop: '20px' }}>
                        <RoundButton onClick={capture} title={"Take Picture"} />
                       
                    </div>

        </>

    );
};

export default WebCam;

